module.exports = __webpack_public_path__ + "img/home_menu_2_default.cf41e363.png";